import React, { Component } from "react";

export class Step3Website extends Component {
  constructor(props) {
    super(props);

    this.state = {
      websiteType: props.formData.websiteType || "",
      pages: props.formData.pages || "",
      domain: props.formData.domain || "Yes",
      hosting: props.formData.hosting || "Yes",
      adminPanel: props.formData.adminPanel || "Yes",
      loginSystem: props.formData.loginSystem || "No",
      paymentGateway: props.formData.paymentGateway || "No",
      seo: props.formData.seo || "Yes",
      description: props.formData.description || "",
      error: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  handleNext = () => {
    if (!this.state.websiteType) {
      this.setState({
        error: "Please select Website Type.",
      });
      return;
    }

    this.props.updateFormData({
      websiteType: this.state.websiteType,
      pages: this.state.pages,
      domain: this.state.domain,
      hosting: this.state.hosting,
      adminPanel: this.state.adminPanel,
      loginSystem: this.state.loginSystem,
      paymentGateway: this.state.paymentGateway,
      seo: this.state.seo,
      description: this.state.description,
    });

    this.props.nextStep();
  };

  render() {
    return (
      <div className="container py-4">

        <div className="card shadow border-0">

          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">
              Step 3 : Website Requirements
            </h3>
          </div>

          <div className="card-body">

            <div className="row">

              {/* Website Type */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Website Type *
                </label>

                <select
                  className="form-select"
                  name="websiteType"
                  value={this.state.websiteType}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  <option>Static Website</option>
                  <option>Dynamic Website</option>
                  <option>E-Commerce Website</option>
                  <option>Portfolio Website</option>
                  <option>School Website</option>
                  <option>Hospital Website</option>
                  <option>Landing Page</option>
                  <option>Custom Website</option>
                </select>
              </div>

              {/* Pages */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Number of Pages
                </label>

                <select
                  className="form-select"
                  name="pages"
                  value={this.state.pages}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  <option>1-5</option>
                  <option>6-10</option>
                  <option>11-20</option>
                  <option>20+</option>
                </select>
              </div>

              {/* Domain */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Need Domain?
                </label>

                <select
                  className="form-select"
                  name="domain"
                  value={this.state.domain}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* Hosting */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Need Hosting?
                </label>

                <select
                  className="form-select"
                  name="hosting"
                  value={this.state.hosting}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* Admin Panel */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Admin Panel
                </label>

                <select
                  className="form-select"
                  name="adminPanel"
                  value={this.state.adminPanel}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* Login */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  User Login System
                </label>

                <select
                  className="form-select"
                  name="loginSystem"
                  value={this.state.loginSystem}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* Payment */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Payment Gateway
                </label>

                <select
                  className="form-select"
                  name="paymentGateway"
                  value={this.state.paymentGateway}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* SEO */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  SEO Optimization
                </label>

                <select
                  className="form-select"
                  name="seo"
                  value={this.state.seo}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* Description */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  Project Description
                </label>

                <textarea
                  rows="5"
                  className="form-control"
                  name="description"
                  placeholder="Describe your project requirements..."
                  value={this.state.description}
                  onChange={this.handleChange}
                />
              </div>

            </div>

            {this.state.error && (
              <div className="alert alert-danger">
                {this.state.error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-primary"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>

        </div>

      </div>
    );
  }
}

export default Step3Website;